import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { SimplifiedCodePreview } from '../CreateFlowcodeForm/CreateFlowcodeFormMobile/CodePreview/CodePreview'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import React from 'react'

export const CombinedFunnelMobileCodePreviewWrapper: React.FC<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  return (
    <Box flexDirection={'column'}>
      <SimplifiedCodePreview width={'214px'} height="214px" />
      <Spacer mb="24px" />
      {children}
    </Box>
  )
}
